import React from "react";
import LicenseChip from "components/LicenseChip";
import { ACTIVATION_TYPES } from "utils/constants";
import DisclosureCard from "components/DisclosureCard";
import { useLocation, useNavigate } from "react-router-dom";
import GridDetailsLayout from "components/GridDetailsLayout";
import ActivationBadgeType from "components/ActivationTypeBadge";
import ActivationStatusChip from "components/ActivationStatusChip";

const CardSx = ({ state }) => {
    const navigate = useNavigate();
    const location = useLocation();

    const previousPath = location.state?.from || "/my/activation-history";

    return (
        <DisclosureCard
            extra={"w-full p-4 sm:overflow-x-auto"}
            button={() => (
                <div className="relative flex items-center justify-between">
                    <div className="flex items-center gap-4">
                        <div className="text-2xl font-bold text-gray-800 dark:text-white">
                            Riepilogo attivazione #{state.code}
                        </div>

                        <ActivationStatusChip value={state.status} />
                    </div>

                    <div className="flex items-center gap-8">
                        <div
                            role="button"
                            onClick={() => {
                                navigate(previousPath);
                            }}
                            className="linear bg-transparent rounded-[8px] border border-brand-500 px-[10px] py-[4px] text-sm font-bold uppercase text-brand-500 transition duration-200 ms-4 hover:bg-brand-600 hover:text-white active:bg-brand-700 active:text-white dark:bg-brand-400 dark:text-brand-500 dark:hover:bg-brand-300 dark:hover:text-white dark:active:bg-brand-200 dark:active:text-white"
                        >
                            Indietro
                        </div>

                        <img
                            src="/icon/chevron-down.svg"
                            alt="Riepilogo attivazione"
                            className="text-[26px] font-bold uppercase text-navy-700 dark:text-white"
                        />
                    </div>
                </div>
            )}
            content={() => (
                <GridDetailsLayout
                    dataConfig={[
                        {
                            key: "Ordine Nr.",
                            value: state.data.reseller_code,
                        },
                        {
                            key: "Data",
                            value: state.created_at,
                        },
                        {
                            key: "Tipologia attivazione",
                            value: (
                                <ActivationBadgeType
                                    text={state.type}
                                    className="ml-1"
                                />
                            ),
                        },
                        ...(state.type === ACTIVATION_TYPES.ONSITE
                            ? [
                                  {
                                      key: "Tipologia maintenance",
                                      value:
                                          state.data.maintenance !== undefined
                                              ? state.data.maintenance ===
                                                "lifetime"
                                                  ? state.data.maintenance
                                                  : state.data.maintenance ===
                                                        0 ||
                                                    state.data.maintenance ===
                                                        "0"
                                                  ? "1 anno incluso"
                                                  : Number(
                                                        state.data.maintenance
                                                    ) +
                                                    1 +
                                                    " anni (1 incluso + " +
                                                    state.data.maintenance +
                                                    " " +
                                                    (state.data.maintenance ===
                                                        1 ||
                                                    state.data.maintenance ===
                                                        "1"
                                                        ? "selezionato"
                                                        : "selezionati") +
                                                    ")"
                                              : "",
                                  },
                              ]
                            : []),
                        ...(state.type === ACTIVATION_TYPES.ONSITE
                            ? [
                                  {
                                      key: "Certificato SSL annuale + dominio",
                                      value: state?.data?.licenses?.find(
                                          (x) => x.code === "ssl"
                                      )?.active
                                          ? "Sì (" +
                                            (state.data.maintenance ===
                                            "lifetime"
                                                ? state.data.maintenance
                                                : state.data.maintenance ===
                                                      0 ||
                                                  state.data.maintenance === "0"
                                                ? "1 anno"
                                                : Number(
                                                      state.data.maintenance
                                                  ) +
                                                  1 +
                                                  " anni") +
                                            ")"
                                          : "No",
                                  },
                              ]
                            : []),
                        {
                            key: "Tipologia licenza",
                            value: state.data.subtype,
                        },
                        {
                            key: "Licenze",
                            value: state.data.licenses.length ? (
                                <div className="ml-1 flex flex-wrap gap-2">
                                    {state.data.licenses.map(
                                        ({
                                            active,
                                            code,
                                            name,
                                            qty,
                                            tooltip,
                                        }) => {
                                            if (!active || code === "ssl") {
                                                return null;
                                            }

                                            return (
                                                <React.Fragment key={code}>
                                                    <LicenseChip
                                                        name={name}
                                                        quantity={qty}
                                                        tooltip={tooltip}
                                                    />
                                                </React.Fragment>
                                            );
                                        }
                                    )}
                                </div>
                            ) : null,
                        },
                        {
                            key: "Note ordine",
                            value: state.data.reseller_note,
                        },
                    ]}
                />
            )}
        />
    );
};

export default CardSx;
